import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useBillRequestDetail = (id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [billInfo, setBillInfo] = useState<BillInfoDto>();
  const [billItems, setBillItems] = useState<BillItemInfoDto[]>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const { isLoading } = useQuery(
    [endpoints.bill.info.request, {id: id}],
    () =>
      fetcher.bill.postBillRequestInfo({id: id}),
    {
      onSuccess: (res: BillInfoResDto) => {
        switch (res.code) {
          case 200:
            setBillInfo(res.result?.info);
            setBillItems(res.result?.items);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  const { mutate: billInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.bill.info.insert_b2b],
    fetcher.bill.postBillInfoInsertB2B,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { billInfo, billItems, insertSuccess, billInsert };
};

export default useBillRequestDetail;
